import { PaymentRelatedTypesKeys } from '@teinor/erp/types/company/config/paymentType'
import NullComponent from '../../../../../../../baseComponents/NullComponent'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import { RectangularInputPrice } from '../../../../../../../forms/Input/InputPrice'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { getCurrencySymbol } from '../../../../../../../utils/globals/price'
import { DictPaymentBanksTy } from '../../../../../../../utils/hooks/payments/getDictPaymentBanks'
import { dictIcon } from '../../../../../../../utils/icons'
import { TPVOrderData } from '../../../types'
import { faCircleCheck, faCircleArrowRight } from '@fortawesome/pro-light-svg-icons'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { DisplayPriceGettingParams } from '../../../../../../../baseComponents/Displays/DisplayPrice'
import { PaymentTypeModelAddExtendedTPV, HookComponentFuntionModalPaymentMethodTPVProps, TPVSetTotalPaymentsCompleteTy, TPVTotalPaymentsCompleteTy } from '../types'
import { TotalByPaymentTypes } from '..'
import { DictVoucherTPVTy } from '../../../../../../../app/erp/screens/TPV/TPVDashboard/types'
import { Fragment } from 'react'

interface PaymentMethodsTypesBoxTPVProps {
    element: PaymentTypeModelAddExtendedTPV
    rowIndex: number
    handleChangeField: (pos: number, field: string, value: any, maxValue?: number) => void
    handleOnBlurTotals: () => void
    completeData: TPVOrderData
    myTotalPayments: TPVTotalPaymentsCompleteTy
    setMyTotalPayments: TPVSetTotalPaymentsCompleteTy
    dictPaymentBanks: DictPaymentBanksTy | null
    hookFuntion: (props: HookComponentFuntionModalPaymentMethodTPVProps) => {
        dictComponentLabels: TwinDictionary;
    }
    totalsByTypes: TotalByPaymentTypes
    dictVouchers?: DictVoucherTPVTy
}

const PaymentMethodsTypesBoxTPV: React.FC<PaymentMethodsTypesBoxTPVProps> = ({ element, rowIndex, handleChangeField, completeData, myTotalPayments, dictPaymentBanks, hookFuntion, handleOnBlurTotals, totalsByTypes, ...rest }) => {
    const myCurrencyId = element?.extraData?.CurrencyId || completeData?.header?.CurrencyId
    const CurrencySymbol = getCurrencySymbol(myCurrencyId)
    const haveErrors = myTotalPayments?.myTotalPayments?.errors?.[element?.PaymentTypeId || 0]
    const borderColor = element.assigned ? (haveErrors ? 'border_red' : 'border-green-43') : 'border-gray-D6'
    const iconColor = element.assigned ? (haveErrors ? 'color_red' : 'text-green-21') : 'text-gray-63'
    const { dictComponentLabels } = hookFuntion({
        element, 
        rowIndex,
        handleChangeField,
        dictPaymentBanks,
        myTotalPayments,
        myCurrencyId,
        ...rest,
    })
    const myElement = { ...element, icon: null }
    const relatedType = myElement.relatedType as PaymentRelatedTypesKeys
    const myNewElement = dictComponentLabels?.[relatedType]
    let myElementRender: JSX.Element | null = null
    const Component = myNewElement?.headerComponent
    const hasComponent = Component && Component !== NullComponent && (!myNewElement.headerConditionRender || myNewElement.headerConditionRender?.(element.quantity))
    if (!hasComponent) {
        myElementRender = <Fragment>
            <RectangularInputPrice label={''} CurrencyId={myCurrencyId} onChange={(value) => handleChangeField(rowIndex, 'quantity', value)} value={element.quantity} className='justify-end flex w-150' name='quantity' onBlur={handleOnBlurTotals} maxValue={totalsByTypes.byPaymentType[element.PaymentTypeId || 0]} minValue={0} />
            <AssignTotalRestButtonTPV {...{ CurrencyId: myCurrencyId, myTotalPayments, handleChangeField, rowIndex, isAssigned: element.assigned }} />
        </Fragment>
    } else {
        myElementRender = <Component {...myElement} {...myNewElement?.extraProps} onChangeField={(maxValue: number) => handleChangeField(rowIndex, 'autocomplete', 1, maxValue)} isHeader={true} />
    }
    return (
        <div className={'w-full py-15 px-30 border payment_box flex flex-col ' + borderColor}>
            <div className='flex w-full gap-x-15'>
                <div className='flex flex-auto items-center gap-x-10'>
                    <TwinIcon icon={dictIcon[element.icon || 'faMoneyBill']} className={'regular20 flex w-24 h-24 ' + iconColor} />
                    <span className='regular16 text-left twin_two_lines_elipsis w-1 flex-auto'>
                        {element.name}
                    </span>
                    <PayedBoxTPV quantityPayed={element.quantityPayed || 0} CurrencyId={myCurrencyId} />
                </div>
                {myElementRender}
            </div>
            <PaymentMethodTypesComponent {...{ myElement: myElement as any, myNewElement, CurrencySymbol, onChangeField: (maxValue: number) => handleChangeField(rowIndex, 'autocomplete', 1, maxValue) }} />
        </div>
    )
}

interface PaymentMethodTypesComponentProps {
    myElement: PaymentTypeModelAddExtendedTPV
    myNewElement: TwinDictionary
    onChangeField: (maxValue: number) => void
}

const PaymentMethodTypesComponent: React.FC<PaymentMethodTypesComponentProps> = ({ myElement, myNewElement, onChangeField }) => {
    const Component = myNewElement?.component || NullComponent
    const hasComponent = Component !== NullComponent
    if (!hasComponent || !myElement.assigned) {
        return null
    }
    return (
        <div className=' border-t border-gray-D6 flex w-full mt-15'>
            <div className='flex w-full mt-10'>
                <div className={'payment_method_label_component flex w-180 pl-30 mt-5 regular14 '}>{myNewElement.label}:</div>
                <Component {...myElement} {...myNewElement?.extraProps} onChangeField={onChangeField} />
            </div>
        </div>
    )
}

interface AssignTotalRestButtonTPVProps {
    rowIndex: number
    handleChangeField: (pos: number, field: string, value: any) => void
    myTotalPayments: TPVTotalPaymentsCompleteTy
    CurrencyId: string
    isAssigned: boolean
}

const AssignTotalRestButtonTPV: React.FC<AssignTotalRestButtonTPVProps> = ({ rowIndex, handleChangeField, myTotalPayments, CurrencyId, isAssigned }) => {
    const { t } = useTwinTranslation()
    if (isAssigned) {
        return (
            <div className='flex items-center text-green-21 w-180  ' >
                <div className='border border-green-43 flex py-3 px-10 items-center' style={{ borderRadius: '5px' }}>
                    <TwinIcon icon={faCircleCheck} className={'mr-5 flex w-16 h-16'} />
                    <span className='regular14 '>
                        {t('assignedSingular', 'Asignado')}
                    </span>
                </div>
            </div>
        )
    }
    if (parseFloat(String(myTotalPayments?.myTotalPayments?.pendingAssigned)) <= 0) {
        return <div className='w-180'></div>
    }
    return (
        <div className='flex items-center text-green-21 w-180 cursor-pointer' onClick={() => handleChangeField(rowIndex, 'autocomplete', null)} >
            <TwinIcon icon={faCircleArrowRight} className={'mr-8 flex w-16 h-16'} />
            <span className='regular14 flex'>
                {t('assign', 'Asignar')} (<DisplayPriceGettingParams CurrencyId={CurrencyId} value={myTotalPayments?.myTotalPayments?.pendingAssigned} with_vat={false} />)
            </span>
        </div>
    )
}

interface PayedBoxTPVProps {
    quantityPayed: number
    CurrencyId: string
}

const PayedBoxTPV: React.FC<PayedBoxTPVProps> = ({ quantityPayed, CurrencyId }) => {
    if (!parseFloat(String(quantityPayed))) {
        return null
    }
    return (
        <div className='flex items-center py-5 px-10 medium14 box_change_tpv'>
            <TwinTrans transKey='paid'>Pagado</TwinTrans>: <span className='ml-5'><DisplayPriceGettingParams CurrencyId={CurrencyId} value={quantityPayed} with_vat={false} /></span>
        </div>
    )
}


export default PaymentMethodsTypesBoxTPV